import type React from 'react';
import { useNavigate } from 'react-router-dom';

interface UnsavedChangesState {
  hasUnsavedChanges: () => boolean;
  onNavigationAttempt: (targetPath: string, proceed: () => void) => void;
}

let unsavedChangesState: UnsavedChangesState | null = null;

export const setUnsavedChangesState = (state: UnsavedChangesState | null) => {
  unsavedChangesState = state;
};

export const useGuardedNavigation = (to: string) => {
  const navigate = useNavigate();

  return (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      return;
    }
    if (unsavedChangesState?.hasUnsavedChanges()) {
      event.preventDefault();
      unsavedChangesState.onNavigationAttempt(to, () => void navigate(to));
    }
  };
};
